<template>
  <section class="container">
    <div class="row">
      <div class="col-lg-6 d-flex flex-column justify-content-center">
        <h2 class="featured-exp-call-out-title">{{ featuredExperience.name }}</h2>
        <p v-html="featuredExperience.description"></p>
        <div>
          <a class="button" v-if="target" rel="noopener noreferrer" target="_blank" :href="featuredExperience.url"> Learn More <IconBase variant="external-link" :classes="`ml-15`" :size="'1.1rem'" :color="'#ffffff'" /> </a>
          <a class="button" v-else :href="featuredExperience.url">
            Learn More
            <span class="ani-chevron"> > </span>
          </a>
        </div>
      </div>
      <div class="col-lg-6">
        <figure class="call-out-image">
          <b-img-lazy
            :style="maxImageSize ? `max-height: ${maxImageSize};` : ''"
            :src="featuredExperience.image"
            class="image-fluid"
            :alt="featuredExperience.image_alt_text"
            role="presentation"
          />
        </figure>
      </div>
    </div>
  </section>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import IconBase from '../../Common/icons/index.vue';

@Component({
  data() {
    return {};
  },
  components: {
    IconBase,
  },
  computed: {
    target() {
      const url = new RegExp('http');
      const u = `${this.featuredExperience.url}`;
      if (url.test(u)) {
        return true;
      }
      return false;
    },
  },
})
class ExperienceFeatured extends Vue {
  @Prop({
    type: [Object],
    required: true,
  })
  featuredExperience;

  @Prop({
    type: String,
    required: false,
  })
  maxImageSize;
}

export default ExperienceFeatured;
</script>

<style scoped>
section {
  margin-top: 75px;
  margin-bottom: 75px;
}
h2 {
  line-height: 60px;
}
a.router-link-active:hover {
  color: #ffffff;
  text-decoration: underline;
}
.call-out-image {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.featured-exp-call-out-title {
  height: 60px !important;
}
.image-fluid {
  width: 100%;
}
@media only screen and (max-width: 768px) {
  .row {
    gap: 2rem;
  }
  .featured-exp-call-out-title {
    height: auto !important;
    line-height: 45px;
  }
}
</style>
